module.exports = __webpack_public_path__ + "img/ic_seekbar_mark.c88aee7f.svg";